import './Loading.css'


function Loading() {
  return (
    <span className='loader'>
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </span>
  );
}

export default Loading;
